export const clearSession = () => sessionStorage.clear();
export const getSession = key => JSON.parse(sessionStorage.getItem(key));
export const removeSession = key => sessionStorage.removeItem(key);
export const setSession = (key, value) =>
  sessionStorage.setItem(key, JSON.stringify(value));



// WEBPACK FOOTER //
// ./src/libs/sessionStorage.js